export enum STATUS_COLOURS {
  Waiting = '#aa62ca',
  Open = '#06b9b9',
  Closed = '#606060',
}